import { z } from 'zod';

/**
 * Cursor-based pagination. Preferred over offset for stable ordering at scale.
 */
export const CursorPaginationQuerySchema = z.object({
  cursor: z.string().optional(),
  limit: z.number().int().min(1).max(200).default(50),
});
export type CursorPaginationQuery = z.infer<typeof CursorPaginationQuerySchema>;

export const CursorPaginationResponseSchema = <T extends z.ZodTypeAny>(itemSchema: T) =>
  z.object({
    items: z.array(itemSchema),
    nextCursor: z.string().nullable(),
  });

export interface CursorPaginationResponse<T> {
  items: T[];
  nextCursor: string | null;
}
